import { ForgotPasswordForm } from "@/components/auth/auth-forms";

export function ForgotPasswordPage() {
  return <ForgotPasswordForm />;
}
